import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import SummaryApi from '../common';

const NotificationBar = () => {
const [barMessage, setBarMessage] = useState('! مرحبا بكم في دواكو');

    
    const fetchBarMessage = async () => {
            try {
                const response = await fetch(SummaryApi.getBarMessage.url, {
                    method: SummaryApi.getBarMessage.method,
                    credentials: 'include',
                    headers: {
                        "Content-Type": 'application/json'
                    }
                });
                const responseData = await response.json();
                setBarMessage(responseData?.data);
            } catch (error) {
            }
        };

        useEffect(() => {
            fetchBarMessage();
        }, []);

    return (
        <div className="bg-blue-900 text-white p-2 text-center">
            {barMessage?.at(0)?.word}
        </div>
    );
};

export default NotificationBar;
